import { useApprovalConfig } from './useApprovalConfig';
import { useApprovalData } from './useApprovalData';
import { useApprovalMeta } from './useApprovalMeta';
export const useApproval = ({
  approvalType,
  approvalAction,
  approvableObjectId,
  assetName,
  approvalObjectIds,
  previewSidebarContent,
  restartOnConclude
}) => {
  var _approvalConfig$confi;
  const approvalConfig = useApprovalConfig(approvalType, approvalAction);
  const approvalData = useApprovalData(approvalType, approvalAction, approvableObjectId, assetName, approvalObjectIds);
  const api = Object.assign({
    fetchConfig: approvalConfig.fetchConfig
  }, approvalData.api);
  const meta = useApprovalMeta({
    approvalType,
    approvalAction,
    approvableObjectId,
    assetName,
    approvalObjectIds,
    previewSidebarContent,
    restartOnConclude,
    approvalData,
    approvalConfig
  });
  const skipConfig = approvalConfig.config.skipApprovalOption ? {
    skipApprovalOption: approvalConfig.config.skipApprovalOption,
    usersIdsListThatCanSkipApproval: (_approvalConfig$confi = approvalConfig.config.usersIdsListThatCanSkipApproval) !== null && _approvalConfig$confi !== void 0 ? _approvalConfig$confi : []
  } : null;
  return {
    api,
    data: approvalData.data,
    config: approvalConfig.config,
    meta,
    skipConfig,
    previewSidebarContent
  };
};